// eslint-disable-next-line no-unused-vars
import React, { useState, useContext } from 'react'
/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { withRouter } from 'react-router-dom'
import { Button, Loader } from '@livechat/design-system'
import queryString from 'query-string'
import IntegrationApiClient from '../api/integration'
import { AuthContext } from '../contexts/auth'
import Welcome from './Welcome'

const loaderWrapperCss = css`
  display: flex;
  align-items: center;
  margin: 20px 0;
  width: 100%;
`

const Slack = ({ readOnly, onConnected, onDisconnected, history }) => {
  const auth = useContext(AuthContext)
  const { version } = auth
  const needsUpdate = version !== parseFloat(process.env.REACT_APP_VERSION)
  const [isConnected, setIsConnected] = useState(!!auth.slack)
  const [isConnecting, setIsConnecting] = useState(false)
  const [hasInstallingStarted, setHasInstallingStarted] = useState(false)

  const integrationApi = new IntegrationApiClient()
  const queryParams = queryString.parse(window.location.search)

  const connect = () => {
    const left = window.screen.width / 2 - 250
    const top = window.screen.height / 2 - 325
    const botScopes = [
      'channels:history',
      'channels:join',
      'channels:manage',
      'channels:read',
      'chat:write',
      'chat:write.customize',
      'commands',
      'files:write',
      'groups:history',
      'groups:read',
      'groups:write',
      'im:read',
      'im:write',
      'mpim:read',
      'mpim:write',
      'team:read',
      'users:read',
      'users:read.email',
    ]

    const userScopes = [
      'channels:history',
      'channels:read',
      'chat:write',
      'files:write',
      'groups:history',
      'groups:read',
      'im:read',
      'mpim:read',
    ]
    window.open(
      `https://slack.com/oauth/v2/authorize?redirect_uri=https://lc-slack-settings.netlify.app/connected&client_id=830849100710.830850400774&user_scope=${userScopes.join(
        ','
      )}&scope=${botScopes.join(',')}&state=install_slack`,
      'popUpWindow',
      `resizable,scrollbars,width=500,height=650,left=${left},top=${top}`
    )
  }

  const install = async code => {
    setHasInstallingStarted(true)

    try {
      await integrationApi.installSlack(code, auth.firebaseToken)
      setIsConnecting(false)
      setIsConnected(true)
      onConnected(true)
      history.push('/')
    } catch (err) {
      setIsConnecting(false)
      setIsConnected(false)
      console.error(err)
    }
  }

  if (!hasInstallingStarted && !isConnected && !isConnecting) {
    switch (queryParams.state) {
      case 'install_slack':
        setIsConnecting(true)
        install(queryParams.code)
        break

      default:
    }
  }

  if (isConnecting) {
    return (
      <div css={loaderWrapperCss}>
        <Loader label="Connecting with Slack..." size="medium" />
      </div>
    )
  }

  if (isConnected && !needsUpdate) {
    return null
  }

  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        height: calc(100vh - 70px);
        align-items: center;
        justify-content: center;
      `}
    >
      <Welcome />
      <Button primary onClick={connect} disabled={readOnly}>
        {needsUpdate ? 'Update is required' : 'Connect'}
      </Button>
    </div>
  )
}

export default withRouter(Slack)
